import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { ComponentProps, ReactNode } from 'react';
import VerticalDotsIcon from '../../assets/icons/vertical-dots.svg?react';
import { cn } from '../../utils/className';

interface TableRowAction {
  label: string;
  onClick: () => void;
  icon?: ReactNode;
  variant?: 'default' | 'danger';
  separator?: boolean;
  disabled?: boolean;
}

export interface TableRowActionsProps extends ComponentProps<'button'> {
  actions: TableRowAction[];
  icon?: ReactNode;
}

export function TableRowActions({
  actions,
  className,
  ...props
}: TableRowActionsProps) {
  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button
          className={cn(
            'flex items-center justify-center rounded-xs',
            'text-surface-focus-strong transition-colors',
            `hover:bg-surface-focus-support
            focus-visible:bg-surface-focus-support`,
            'focus-visible:outline-none',
            '[&_path]:fill-current [&_svg]:fill-current',
            'cursor-pointer',
            className
          )}
          onClick={(e) => e.stopPropagation()}
          {...props}
        >
          <VerticalDotsIcon className='h-6 w-6' />
        </button>
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <DropdownMenu.Content
          align='end'
          sideOffset={4}
          onClick={(e) => e.stopPropagation()}
          className={cn(
            'z-50 min-w-40 overflow-hidden rounded-lg',
            'border-border-primary bg-surface-primary border',
            'animate-in fade-in-0 zoom-in-95'
          )}
        >
          {actions.map((action, index) => (
            <div key={index}>
              <DropdownMenu.Item
                onClick={action.disabled ? undefined : action.onClick}
                disabled={action.disabled}
                className={cn(
                  'relative flex cursor-pointer items-center gap-2 select-none',
                  'size-p2 rounded px-2 py-2 transition-colors outline-none',
                  'focus:bg-surface-focus-support',
                  'text-secondary',
                  action.disabled && 'cursor-not-allowed opacity-50'
                )}
              >
                {action.icon ? (
                  <span
                    className='flex h-4 w-4 shrink-0 items-center justify-center
                      [&_path]:fill-current [&_svg]:fill-current'
                  >
                    {action.icon}
                  </span>
                ) : null}
                <span>{action.label}</span>
              </DropdownMenu.Item>
            </div>
          ))}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
